import ZW_SWITCH from './ZW-SWITCH.js';
import ZW_COVER from './ZW-COVER.js';
import ZW_DIMMER from './ZW-DIMMER.js';
import ZW_SENSOR from './ZW-SENSOR.js';
import ZW_INPUT from './ZW-INPUT.js';

export const ZWave = {
	'ZW-SWITCH': ZW_SWITCH,
	'ZW-COVER': ZW_COVER,
	'ZW-DIMMER': ZW_DIMMER,
	'ZW-SENSOR': ZW_SENSOR,
	'ZW-INPUT': ZW_INPUT,
};
